import React from 'react';
import { colors } from '../styles/colors';
import { typography } from '../styles/typography';

const CustomButton = ({ 
  title, 
  onPress, 
  onClick,
  variant = 'primary', 
  disabled = false, 
  style = {},
  textStyle = {} 
}) => {
  // Support both onPress (React Native style) and onClick (web style)
  const handleClick = onPress || onClick;
  const buttonStyles = {
    ...styles.button,
    ...styles[variant],
    ...(disabled && styles.disabled),
    ...style
  };

  const textStyles = {
    ...styles.text,
    ...styles[`${variant}Text`],
    ...(disabled && styles.disabledText),
    ...textStyle
  };

  return (
    <button
      style={buttonStyles}
      onClick={disabled ? undefined : handleClick}
      disabled={disabled}
    >
      <span style={textStyles}>{title}</span>
    </button>
  );
};

const styles = {
  button: {
    paddingTop: 14,
    paddingBottom: 14,
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: 8,
    border: 'none',
    cursor: 'pointer',
    marginTop: 5,
    marginBottom: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  primary: {
    backgroundColor: colors.primary,
  },
  secondary: {
    backgroundColor: colors.secondary,
  },
  outline: {
    backgroundColor: 'transparent',
    border: `2px solid ${colors.primary}`,
  },
  danger: {
    backgroundColor: colors.danger,
  },
  disabled: {
    backgroundColor: colors.lightGray,
    cursor: 'not-allowed',
  },
  text: {
    ...typography.body,
    fontWeight: '600',
  },
  primaryText: {
    color: colors.white,
  },
  secondaryText: {
    color: colors.white,
  },
  outlineText: {
    color: colors.primary,
  },
  dangerText: {
    color: colors.white,
  },
  disabledText: {
    color: colors.gray,
  },
};

export default CustomButton;